(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-page-template"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('#brand-list--{{ section.id }} a[href^="#"]');
  
  links.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        // Calculate center position
        const viewportHeight = window.innerHeight;
        const targetRect = target.getBoundingClientRect();
        const scrollPosition = window.scrollY + targetRect.top - (viewportHeight/2) + (targetRect.height/2);
        
        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth'
        });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-tab"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener('DOMContentLoaded',()=>{const togglers=document.querySelectorAll('[data-toggle]');const tabLinks=document.querySelectorAll('.tab-link');const faqContainers=document.querySelectorAll('.faq-container');togglers.forEach((btn)=>{btn.addEventListener('click',(e)=>{const selector=e.currentTarget.dataset.toggle;const block=document.querySelector(`${selector}`);if(e.currentTarget.classList.contains('active')){block.style.maxHeight='';block.classList.remove('open')}else{block.style.maxHeight=block.scrollHeight+'px';block.classList.add('open')}
e.currentTarget.classList.toggle('active')})});tabLinks.forEach(link=>{link.addEventListener('click',(e)=>{e.preventDefault();const target=e.currentTarget.dataset.target;faqContainers.forEach(container=>{container.classList.remove('active')});document.querySelector(target).classList.add('active');tabLinks.forEach(tab=>{tab.classList.remove('active')});e.currentTarget.classList.add('active')})})})

  } catch(e) { console.error(e); }
})();
})();
